import PropTypes from 'prop-types';
import React from 'react';
import { Card, Grid, Icon } from 'semantic-ui-react';
import moment from 'moment-timezone';
import LocationUtils from '../../../lib/utils/location';
import DateUtils from '../../../lib/utils/date';
import styles from './EventSegment.scss';

export default class EventSegmentShow extends React.Component {
  static propTypes = {
    compact: PropTypes.bool,
    eventSegment: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
    noBorder: PropTypes.bool
  };

  render() {
    const { eventSegment } = this.props;
    const venueTitle =
      (eventSegment.location || '') +
      (eventSegment.room ? ` (${eventSegment.room})` : '');

    const hasTimes = eventSegment.start_at && eventSegment.end_at;
    const startAt = DateUtils.isoStringToMoment(
      eventSegment.start_at,
      eventSegment.all_day,
      eventSegment.time_zone
    );
    const endAt = DateUtils.isoStringToMoment(
      eventSegment.end_at,
      eventSegment.all_day,
      eventSegment.time_zone
    );
    const allDay = eventSegment.all_day;
    const timeZone = moment.tz(eventSegment.time_zone).format('z');

    const isSingleDayEvent = () =>
      startAt.isSame(endAt, 'day') ||
      (startAt.isSame(moment(endAt).subtract(6, 'hours'), 'day') && !allDay);
    // Include year formatter if date is not this year
    const yearFormat =
      moment().isSame(startAt, 'year') && moment().isSame(endAt, 'year')
        ? ''
        : ', YYYY';
    const primaryTimeInfo = () => {
      if (isSingleDayEvent()) {
        // If single day, return day of week
        return startAt.format(`dddd, MMMM D${yearFormat}`);
      }
      // If multi-day event, return date range
      return `${startAt.format(`MMMM D${yearFormat}`)} – ${endAt.format(
        `MMMM D${yearFormat}`
      )}`;
    };
    const secondaryTimeInfo = () => {
      // If date with no times, return All Day
      if (eventSegment.all_day) {
        return 'All Day';
      }
      if (isSingleDayEvent()) {
        // If single day, return times only
        return `${startAt.format('LT')} – ${endAt.format('LT')} ${timeZone}`;
      }
      // If multi-day event, return dates and times
      // Don't forget YEAR formatting!
      return `${startAt.format(`MMM D${yearFormat} [at] LT`)} – ${endAt.format(
        `MMM D${yearFormat} [at] LT`
      )} ${timeZone}`;
    };
    const venueText = (
      <div>
        {venueTitle}
        <span className={styles.secondaryInfo}>
          {eventSegment.line1 && <br />}
          {eventSegment.line1}
          {(eventSegment.city ||
            eventSegment.province ||
            eventSegment.postal_code) &&
            <br />}
          {LocationUtils.getLocalityString({
            city: eventSegment.city,
            province: eventSegment.province,
            postal_code: eventSegment.postal_code
          })}
        </span>
      </div>
    );

    const cardStyles = { background: 'transparent' };
    if (this.props.noBorder) cardStyles.boxShadow = 'none';

    return (
      <Card link={!this.props.readOnly} fluid style={cardStyles}>
        <Card.Content>
          <Grid stackable>
            <Grid.Row columns={1}>
              <Grid.Column>
                <h3>
                  {eventSegment.title}
                </h3>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={this.props.compact ? 1 : 'equal'}>
              <Grid.Column
                style={this.props.compact ? { marginBottom: '2em' } : {}}
              >
                <div style={{ display: 'flex' }}>
                  <div className={styles.icon}>
                    <Icon name='calendar alternate outline' />
                  </div>
                  <span>
                    {hasTimes &&
                      <div>
                        {primaryTimeInfo()}
                        <br />
                        <span className={styles.secondaryInfo}>
                          {secondaryTimeInfo()}
                        </span>
                      </div>}
                    {!hasTimes && <p>N/A</p>}
                  </span>
                </div>
              </Grid.Column>
              <Grid.Column>
                {(venueTitle !== '' || eventSegment.notes) &&
                  <div style={{ display: 'flex' }}>
                    <div className={styles.icon}>
                      <Icon name='map marker alternate' />
                    </div>
                    <span>
                      <div>
                        {venueText}
                      </div>
                    </span>
                  </div>}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/EventSegment/EventSegmentShow.js